import React from "react";
import {useForm} from "react-hook-form";
import {ClientRequest, createJwt} from "../../common/ClientRequest";
import {toast} from "react-toastify";
import BgBtnSubmit from "../../assets/images/bg-btn-green.png"

export const FormRegister: React.FC<{ onSuccess: (tel: string) => void }> = ({onSuccess}) => {
    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm();

    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const handleOnSubmit = async (data: any) => {
        const {fullName, age, fullNameParent, phoneNumber} = data;
        setIsLoading(true);
        const {code, message} = await ClientRequest("/betia-service/v2/eventRegister/insertRegisterBaVi", {
            jwt: createJwt({
                fullName: fullName,
                fullNameParent: fullNameParent,
                tel: phoneNumber,
                age: age,
                eventCode: "BAVI"
            })
        });
        setIsLoading(false);
        if (code === 0 || code === 100) {
            if (code === 0) {
                toast("Đăng ký thành công", {type: "success"});
            }
            onSuccess(phoneNumber);
        } else {
            toast(message, {type: "error"});
        }
    }

    return <form action="#" className={"mt-8 xl:mt-0 mx-auto rounded-[24px] bg-[#439BDD] p-[30px]"} onSubmit={handleSubmit(handleOnSubmit)}>
        <h4 className={"text-center font-bold text-[1.875rem] text-white text-center"}>ĐĂNG KÝ NHẬN MÃ TRẢI NGHIỆM 07 NGÀY BETIA ENGLISH</h4>
        <ul className={"mt-4"}>
            <li>
                <label className={"font-myriad text-[14px] text-white"}>Họ và tên học sinh <span
                    className={"text-[#C81E1E]"}>*</span></label>
                <input className={"form-field"}
                       key={"fullName"}
                       placeholder={"Nhập tại đây..."}
                       type="text"
                       {...register('fullName', {
                           required: "Không được bỏ trống",
                           minLength: {
                               value: 6,
                               message: "Họ và tên phải lớn hơn 6 ký tự"
                           },
                           maxLength: {
                               value: 32,
                               message: "Họ và tên phải nhỏ hơn 32 ký tự"
                           }
                       })}/>
                <p className={"mt-0 error-message"}>{errors?.fullName?.message as string}</p>
            </li>
            <li>
                <label className={"font-myriad text-[14px] text-white"}>Độ tuổi học sinh <span
                    className={"text-[#C81E1E]"}>*</span></label>
                <input className={"form-field"} placeholder={"Nhập tại đây..."} type="text"
                       {...register('age', {
                           required: "Không được bỏ trống",
                           pattern: {
                               value: /^[0-9]{1,2}$/,
                               message: "Độ tuổi không hợp lệ"
                           }
                       })}/>
                <p className={"mt-0 error-message"}>{errors?.age?.message as string}</p>
            </li>
            <li>
                <label className={"font-myriad text-[14px] text-white"}>Họ và tên phụ huynh <span
                    className={"text-[#C81E1E]"}>*</span></label>
                <input className={"form-field"} placeholder={"Nhập tại đây..."} type="text"
                       {...register('fullNameParent', {
                           required: "Không được bỏ trống",
                           minLength: {
                               value: 6,
                               message: "Họ và tên phải lớn hơn 6 ký tự"
                           },
                           maxLength: {
                               value: 32,
                               message: "Họ và tên phải nhỏ hơn 32 ký tự"
                           }
                       })}/>
                <p className={"mt-0 error-message"}>{errors?.fullNameParent?.message as string}</p>
            </li>
            <li>
                <label className={"font-myriad text-[14px] text-white"}>Số điện thoại phụ huynh <span
                    className={"text-[#C81E1E]"}>*</span></label>
                <input className={"form-field"}
                       placeholder={"Nhập tại đây..."}
                       {...register('phoneNumber', {
                           required: "Không được bỏ trống",
                           pattern: {
                               value: /^0[0-9]{9}$/,
                               message: "Số điện thoại không hợp lệ"
                           }
                       })}
                       type="text"/>
                <p className={"mt-0 error-message"}>{errors?.phoneNumber?.message as string}</p>
            </li>
            <li className={"mt-4"}>
                <button className={"w-full py-[.875rem] disabled:bg-[#c1c1c1] text-[#0C3D77] font-bold rounded-xl cursor-pointer"}
                        disabled={isLoading}
                        type={"submit"}>
                    <img src={BgBtnSubmit} alt=""/>
                </button>
            </li>
        </ul>
    </form>;
}
